import List from './List.container'

export default List
